import React from 'react';
import { SpotSuperShort } from 'domain/Spot';
import { Box, Button, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';

interface SpotPreviewProps {
    data: SpotSuperShort;
}

const openGoogleMaps = (latitude: number, longitude: number) => {
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, '_blank');
};

export const SpotOptions = ({ data: spot }: SpotPreviewProps) => {
    const history = useHistory();
    return (
        <Box display={'flex'} flexDirection={'column'} textAlign={'center'}>
            <Box mb={1}>
                <Button
                    variant={'outlined'}
                    size={'small'}
                    sx={{
                        fontSize: '.9rem',
                    }}
                    onClick={() => {
                        history.push(`/spot-detail/${spot.id}`);
                    }}
                >
                    Open in KwadHub
                </Button>
            </Box>
            <Box>
                <Button
                    variant={'outlined'}
                    size={'small'}
                    sx={{
                        fontSize: '.9rem',
                    }}
                    onClick={() => {
                        // TODO: Decide to truncate or not
                        openGoogleMaps(spot.lat, spot.lng);
                    }}
                >
                    Open in Google Maps
                </Button>
            </Box>
        </Box>
    );
};

const SpotPreview = ({ data: spot }: SpotPreviewProps) => {
    return (
        <Box>
            <Typography
                variant={'body1'}
                sx={{
                    fontSize: '1.2rem',
                    fontWeight: 700,
                    mb: 2,
                }}
            >
                {spot.name}
            </Typography>
            <Typography variant={'body1'}>{spot.description}</Typography>
        </Box>
    );
};

export default SpotPreview;
